import { render, staticRenderFns } from "./DoubleSideBar.vue?vue&type=template&id=0d4eddb6&"
import script from "./DoubleSideBar.vue?vue&type=script&lang=js&"
export * from "./DoubleSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports